import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';
import { noop, ScrollViewWithHeaderTitle, theme } from '@sweetgreen/garnish';

import { useCustomer } from '@order/Customer';
import { useLocalizationContext } from '@order/Localization';

import { AccountScreenTitle } from '../../../components/Account';
import { PaymentMethodList } from '../../../components/PaymentMethod';
import { TransparentModal } from '../../../components/TransparentModal';
import { useScanToPayNavigation } from '../ScanToPay.navigation';

export const ScanToPayPayments = () => {
  const { t } = useLocalizationContext();
  const { customer } = useCustomer();
  const title = t('account.scan-to-pay.payments');
  const { handleSelectPaymentMethod, handleSelectAddPaymentMethod } =
    useScanToPayNavigation();
  const { bottom, top } = useSafeAreaInsets();
  const dynamicPadding = useStyle(() => {
    return {
      paddingTop: Math.max(theme.spacing.medium, top),
      paddingBottom: Math.max(theme.spacing.medium, bottom),
    };
  }, [top, bottom]);

  return (
    <TransparentModal size="full" onClose={noop}>
      <ScrollViewWithHeaderTitle testID="stp.payments.root.container">
        <View
          testID="scan-to-pay.payments.route"
          style={[styles.padding, dynamicPadding]}
        >
          <AccountScreenTitle title={title} />
          <PaymentMethodList
            items={customer.billingAccounts ?? []}
            onSelectItem={handleSelectPaymentMethod}
            onSelectAdd={handleSelectAddPaymentMethod}
          />
        </View>
      </ScrollViewWithHeaderTitle>
    </TransparentModal>
  );
};

const styles = StyleSheet.create({
  padding: {
    flex: 1,
    backgroundColor: theme.colors.KHAKI_3,
    paddingHorizontal: theme.spacing.medium - theme.spacing.xsmall,
  },
});
